export const ClinicControllerFactory = ({
  clinicService,
}: {
  clinicService: IClinicService;
}) => {
  return {
    getClinicFloor: clinicService.getClinicFloor,
    getMyClinics: clinicService.getMyClinics,
    getSelectedClinic: clinicService.getSelectedClinic,
    setDefaultClinic: clinicService.setDefaultClinic,
    setSelectedClinic: clinicService.setSelectedClinic,
    setClinicFloor: clinicService.setClinicFloor,
    logError: clinicService.logError,
    fetchAssignedDevice: clinicService.fetchAssignedDevice,
    assingDeviceToAPatient: clinicService.assingDeviceToAPatient,
    deleteAccount: clinicService.deleteAccount,
    disconnectDevice: clinicService.disconnectDevice,
    setDeviceWifi: clinicService.setDeviceWifi,
  };
};
